module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('masthead'), _vm._v(" "), _c('navigation'), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('site-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-59c95520!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 396
// module chunks = 2